export function NewsroomCustomColorSchemeRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.NewsroomCustomColorScheme', {
		url: '/newsroom/customcolorscheme',
		controllerAs: 'vm',
		controller: NewsroomCustomColorSchemeCtrl,
		templateUrl: '/ng/hub/Newsroom/CustomColorScheme/NewsroomCustomColorSchemeCtrl.html?' + window.BUILD,
		resolve: {},
	});
}

export class NewsroomCustomColorSchemeCtrl {
	constructor(Api) {
		'ngInject';
		this.Api = Api;
		this.name = '';
		this.colors = [];
	}

	save() {
		// Make sure there's a name entered and at least one color.
		if (this.name && this.colors.length >= 1) {
			let colors = this.colors.filter(Boolean).map(color => {
				return { bgColor: color, fgColor: '#ffffff' }; // fgColor defaults to white for now.
			});
			let data = {
				name: this.name,
				colors: colors,
			};
			const url = '/newsrooms/color_schemes';
			this.Api.request('post', url, data).then(resp => {
				let newSchemeId = resp.headers('api-new-record-id');
				this.$resolve(newSchemeId);
			});
		} else {
			alert('Please enter a name for this color scheme and add at least 1 color');
		}
	}
}
